(function(){

  /* 1) Shipping info line on product pages */
  function addProductInfo(){
    if (document.querySelector('.ss-ship-info')) return;
    /* only inside the product page info column, never in collection cards (quick add forms) */
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var anchor = info.querySelector('.product-form__buttons') || info.querySelector('product-form') || info.querySelector('.price');
    if (!anchor) return;
    var el = document.createElement('div');
    el.className = 'ss-ship-info';
    el.innerHTML =
      '<div class="ss-ship-info__row"><span class="ss-ship-info__ic">🚚</span><span><strong>Ships Mon–Thu</strong>, packed cold</span></div>' +
      '<div class="ss-ship-info__row"><span class="ss-ship-info__ic">✓</span><span>Northeast: next-day, $10 · <strong>FREE on orders $99+</strong></span></div>' +
      '<div class="ss-ship-info__row"><span class="ss-ship-info__ic">✓</span><span>Other states: <strong>FREE 2-day delivery</strong> from $125 or $200 · next-day express available</span></div>' +
      '<div class="ss-ship-info__row"><span class="ss-ship-info__ic">ⓘ</span><span>Minimum order $50</span></div>';
    var container = anchor.closest('.product-form') || anchor;
    container.parentNode.insertBefore(el, container.nextSibling);
  }

  /* 2) Free-delivery wording in FAQ / accordions / page sections (zone thresholds) */
  var NE = 'NY, NJ, CT, PA, MA, RI, DE, MD and DC';
  var OTHER = 'Other states: FREE 2-day delivery on orders $125+ (East & Midwest) or $200+ (Florida and the rest of the US); smaller orders and next-day express are calculated at checkout.';
  var SWAP = [
    ['Delivery $25, FREE on orders $175+.', 'Delivery $10 to ' + NE + ', FREE on orders $99+. ' + OTHER],
    ['$25, FREE on orders $175+.', '$10 next-day in the Northeast (FREE on orders $99+); FREE 2-day delivery elsewhere from $125 or $200.'],
    ['FREE next-day delivery on orders $175+', 'FREE next-day delivery from $99 in the Northeast'],
    ['FREE delivery on orders $175+', 'FREE delivery from $99 in the Northeast'],
    ['Delivery is $25 and FREE on orders $175+.', 'Delivery is $10 to ' + NE + ' and FREE on orders $99+. ' + OTHER + ' Enter your ZIP in the cart to see yours.'],
    ['FREE on orders $175+', 'FREE from $99 in the Northeast']
  ];
  var onShipPage = /\/pages\/shipping-delivery/.test(location.pathname);
  function swapText(root){
    if (!root || !document.createTreeWalker) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = tw.nextNode())) {
      var v = n.nodeValue;
      
      if (v.indexOf('175+') === -1) continue;
      for (var i = 0; i < SWAP.length; i++) { if (v.indexOf(SWAP[i][0]) > -1) { v = v.split(SWAP[i][0]).join(SWAP[i][1]); } }
      if (v !== n.nodeValue) n.nodeValue = v;
    }
  }


  /* 3) Chat: floating bubble only on the homepage; elsewhere a "Chat with us" link in the menu opens it */
  (function(){
    var root = document.documentElement;
    if (location.pathname !== '/') root.classList.add('ss-nochat');
    var st = document.createElement('style');
    st.textContent = '.ss-nochat:not(.ss-chat-open) shopify-chat{visibility:hidden !important;pointer-events:none !important}' +
      '.ss-chat-link{display:flex;align-items:center;gap:.6rem;cursor:pointer}';
    document.head.appendChild(st);
    function openChat(e){
      if (e) e.preventDefault();
      var d = document.querySelector('header-drawer details[open], .menu-drawer-container[open]');
      if (d) { var s = d.querySelector('summary'); if (s) s.click(); }
      root.classList.add('ss-chat-open');
      var tries = 0;
      (function go(){
        var c = document.querySelector('shopify-chat'), b = c && c.shadowRoot && c.shadowRoot.querySelector('button.activator, button');
        if (b) { b.click(); return; }
        if (++tries < 20) setTimeout(go, 250);
      })();
    }
    function addLinks(){
      if (document.querySelector('.ss-chat-link')) return;
      var label = '<span aria-hidden="true">&#128172;</span><span>Chat with us</span>';
      var mob = document.querySelector('.menu-drawer__menu');
      if (mob) {
        var li = document.createElement('li');
        li.innerHTML = '<a href="#chat" class="menu-drawer__menu-item list-menu__item link link--text focus-inset ss-chat-link">' + label + '</a>';
        mob.appendChild(li);
      }
      var desk = document.querySelector('.header__inline-menu .list-menu--inline');
      if (desk) {
        var li2 = document.createElement('li');
        li2.innerHTML = '<a href="#chat" class="header__menu-item list-menu__item link link--text focus-inset ss-chat-link"><span>Chat</span></a>';
        desk.appendChild(li2);
      }
      document.addEventListener('click', function(e){ if (e.target.closest('.ss-chat-link')) openChat(e); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addLinks); else addLinks();
  })();

  function init(){ addProductInfo(); swapText(document.body); setTimeout(function(){ swapText(document.body); }, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
